import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import AudioExtractorWorkListRender from './children/AudioExtractorWorkListRender';
import AudioExtractorWorkOperationRender from './children/AudioExtractorWorkOperationRender';
import Process from '@/components/common/process/Process';
import Upload from '../../../../upload/Upload';
import { ReactComponent as FilePurpleIcon } from '@/assets/icons/file-purple.svg';
import { ReactComponent as OutPutIcon } from '@/assets/icons/output.svg';
import '@/assets/audioExtractor.less';
import { Button } from 'antd';
import sentGAEvent from '@/ga';
import Utils from '@/utils';
import ModalAdvertise from '../../../modalAdvertise';
import Cookies from 'js-cookie';
class AudioExtractWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      format: 'mp3',
      videoAccept:
        '.mkv,.mov,.mp4,.avi,.wmv,.vob,.webm,.asf,.f4v,.flv,.mpg,.mpeg,.ts,.mxf,.ogv,.swf,.gif',
    };
  }

  handleCompress = () => {
    sentGAEvent({
      category: 'audio_extractor_output',
      action: 'audio_extractor_output_click',
    });
    let flag = Utils.handleVideoEditorTimes('26AE');
    if (flag) {
      return false;
    }
    const { format, quality } = this.state;
    this.props.handleSubmit(format, quality);
    if (
      Utils.getSystemType() != 'other' &&
      +Cookies.get('videoEditorTimes') <= 6
    ) {
      this.props.advertiseConfig({
        isShowBtn: false,
        isShowHeader: true,
        headerObj: 'extract',
        titleIndex: 3,
        imgIndex: 2,
        source: 'extract',
      });
      this.props.openAdvertiseDialog(true);
      sentGAEvent({
        category: 'vc_referral',
        action: 'AudioExtractor_ExtractingShow',
      });
    }
  };

  handleFormat = (format) => {
    console.log(format);
    this.setState({ format });
  };

  render() {
    const systemType = Utils.getSystemType() != 'other' ? true : false;
    const { t } = this.props;
    return (
      <div className='workplace-container'>
        <div className={`step-con ${this.props.submitting ? 'disabled' : ''}`}>
          <div className='step-header'>
            <span className='step-num active'>
              <span>1</span>
            </span>
            <div className='step-item'>
              <FilePurpleIcon />
              <span> {t('upload:Choose File')}</span>
            </div>
          </div>
          {this.props.audioExtractorFile ? (
            <AudioExtractorWorkListRender
              audioExtractorFile={this.props.audioExtractorFile}
              deleteAudioExtractFile={this.props.deleteAudioExtractFile}
              uploadProps={this.props.uploadProps}
              submitting={this.props.submitting}
            />
          ) : (
            <div style={{ padding: '53px 46px 66px' }}>
              <Upload
                visible
                addFileByUrlVisible
                theme='light'
                addFileCallBack={this.props.onChangeAudioExtractorFile}
                accept={this.state.videoAccept}
              />
            </div>
          )}
        </div>

        <AudioExtractorWorkOperationRender
          submitting={this.props.submitting}
          handleFormat={this.handleFormat}
        />
        <div className='step-con'>
          <div className='step-header'>
            <span className='step-num active'>
              <span>3</span>
            </span>
            <div className='step-item'>
              <OutPutIcon />
              <span>{t('Extract Audio')}</span>
            </div>
          </div>
          <div className='step-cont btn-cont'>
            {this.props.submitting ? (
              systemType ? null : (
                <div className='process-cont'>
                  <div>
                    <Process
                      visible
                      theme='light'
                      showProcessText
                      processText={t('Extracting Audio')}
                      hideCancelText
                      cancelProcessCallBack={this.props.cancelProcessCallBack}
                    />
                  </div>
                </div>
              )
            ) : (
              <Button
                type='primary'
                size='large'
                disabled={!this.props.audioExtractorFile}
                onClick={this.handleCompress}
              >
                {t('Extract Audio')}
              </Button>
            )}
          </div>
        </div>
        {Utils.getSystemType() != 'other' ? (
          <ModalAdvertise
            cancelProcessCallBack={this.props.cancelProcessCallBack}
          />
        ) : null}
      </div>
    );
  }
}

export default withTranslation(['audioExtractor', 'upload'])(
  AudioExtractWorkFunction
);
